/**
 * Badge môi trường topbar (US-AE-IMP.F1-0110-S03 · @UC9136). Suy nhãn + tone từ raw build env
 * (Vite: VITE_APP_ENV ưu tiên, fallback import.meta.env.MODE) — KHÔNG hardcode "PRODUCTION".
 *
 * Bất biến chống-nhầm: chỉ đúng chuỗi production/prod mới ra nhãn PRODUCTION (tone danger). Mọi giá
 * trị unset/rỗng/lạ ⇒ LOCAL (tone neutral) — an toàn, không bao giờ tự nhận là môi trường thật.
 */
export type EnvTone = "info" | "warning" | "danger" | "neutral";

export interface EnvBadge {
  readonly label: string;
  readonly tone: EnvTone;
}

/** Thuần & deterministic: map raw env (đã chuẩn hoá trim+lowercase) → nhãn + tone. */
export function resolveEnvBadge(raw: string | undefined | null): EnvBadge {
  switch ((raw ?? "").trim().toLowerCase()) {
    case "development":
    case "dev":
      return { label: "DEVELOPMENT", tone: "info" };
    case "staging":
    case "stg":
      return { label: "STAGING", tone: "warning" };
    case "production":
    case "prod":
      return { label: "PRODUCTION", tone: "danger" };
    default:
      // unset / lạ / rỗng → LOCAL (KHÔNG mặc định PRODUCTION).
      return { label: "LOCAL", tone: "neutral" };
  }
}

/**
 * Đọc raw env build-time từ Vite. Nguồn TIN CẬY = `VITE_APP_ENV` (đặt tường minh cho từng môi
 * trường build: staging build set =staging, prod build set =production). Tách riêng để component
 * chỉ gọi 1 chỗ.
 *
 * CHỐNG NHẦM (quan trọng): MỌI `vite build` đều gán MODE="production" (kể cả build staging/preview/
 * e2e) → KHÔNG suy PRODUCTION từ MODE, nếu không mọi bản build sẽ tự nhận là prod (đúng bug story).
 * Chỉ tin MODE khi ="development" (vite dev = máy dev). Thiếu VITE_APP_ENV ở bản build ⇒ "" ⇒ LOCAL.
 */
export function readAppEnv(): string {
  const explicit = import.meta.env.VITE_APP_ENV;
  if (typeof explicit === "string" && explicit.length > 0) return explicit;
  return import.meta.env.MODE === "development" ? "development" : "";
}
